
// // import React, { useState, useEffect, useRef, useContext } from "react";
// // import { Link, useHistory } from "react-router-dom";
// // import { FiSearch, FiMapPin, FiChevronDown, FiSliders } from "react-icons/fi";
// // import { RiHomeLine } from "react-icons/ri";
// // import {
// //   FaHome,
// //   FaBuilding,
// //   FaTree,
// //   FaCity,
// //   FaBed,
// //   FaArrowRight,
// //   FaStar,
// //   FaUsers,
// //   FaFire,
// //   FaRupeeSign,
// //   FaPercent,
// //   FaShieldAlt,
// //   FaLock,
// //   FaCamera,
// //   FaMagic,
// // } from "react-icons/fa";
// // import { SearchContext } from "./SearchContext";

// // /* ------------------------------------------------------------------ */
// // /*  THEME COLORS (change here if you want a different maroon / gold)   */
// // /*  maroon : #7a0f2e     dark maroon : #5c0a22     gold : #f2b632    */
// // /* ------------------------------------------------------------------ */

// // const Search = () => {
// //   /* ================= LOGIC (UNCHANGED) ================= */
// //   const history = useHistory();

// //   const { searchCity, setSearchCity } = useContext(SearchContext);
// //   const [searchQuery, setSearchQuery] = useState("");
// //   const GOOGLE_MAPS_API_KEY = "AIzaSyAt8bj4UACvakZfiSy-0c1o_ivfplm7jEU";
// //   const [type, setType] = useState("");
// //   const [error, setError] = useState("");
// //   const inputRef = useRef(null);
// //   const handleCityChange = (e) => {
// //     const selectedCity = e.target.value;
// //     setSearchCity(selectedCity);
// //   };

// //   const handleSearch = () => {
// //     if (!searchQuery && !searchCity && !type) {
// //       setError("Please enter what you're looking for.");
// //       return;
// //     }

// //     setError("");
// //     history.push({
// //       pathname: "/searchdashboard",
// //       state: {
// //         searchCity,
// //         searchQuery,
// //         type,
// //       },
// //     });
// //   };

// //   useEffect(() => {
// //     const loadGoogleMapsScript = () => {
// //       if (window.google && window.google.maps) {
// //         initAutocomplete();
// //         return;
// //       }

// //       const script = document.createElement("script");
// //       script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`;
// //       script.async = true;
// //       script.defer = true;

// //       script.onload = () => {
// //         initAutocomplete();
// //       };

// //       document.body.appendChild(script);
// //     };

// //     const initAutocomplete = () => {
// //       const autocomplete = new window.google.maps.places.Autocomplete(
// //         inputRef.current,
// //         {
// //           types: ["(cities)"],
// //           componentRestrictions: { country: "in" },
// //         }
// //       );

// //       autocomplete.addListener("place_changed", () => {
// //         const place = autocomplete.getPlace();

// //         if (place && place.name) {
// //           setSearchQuery(place.name);
// //           setSearchCity(place.name);
// //         }
// //       });
// //     };

// //     loadGoogleMapsScript();
// //   }, []);
// //   useEffect(() => {
// //     if (!window.google) return;

// //     const autocomplete = new window.google.maps.places.Autocomplete(
// //       inputRef.current,
// //       {
// //         types: ["(cities)"],
// //         componentRestrictions: { country: "in" },
// //       }
// //     );

// //     autocomplete.addListener("place_changed", () => {
// //       const place = autocomplete.getPlace();

// //       if (place && place.name) {
// //         setSearchQuery(place.name);
// //         setSearchCity(place.name);
// //       }
// //     });
// //   }, []);
// //   /* ================= END LOGIC ================= */

// //   /* UI-only data (static, no logic) */
// //   const propertyTabs = [
// //     { label: "Buy", type: "Buy" },
// //     { label: "Rent", type: "Rent" },
// //     { label: "PG", type: "PG/Co-living" },
// //     { label: "Plots/Land", type: "Plot/Land" },
// //     { label: "Commercial", type: "Commercial" },
// //   ];

// //   const popularCities = ["Indore", "Bhopal", "Mumbai", "Pune", "Delhi"];

// //   const stats = [
// //     { icon: <FaHome />, value: "50,000+", label: "Property Listings" },
// //     { icon: <FaUsers />, value: "10,000+", label: "Verified Owners" },
// //     { icon: <FaCity />, value: "50+", label: "Cities Across India" },
// //     { icon: <FaStar />, value: "4.8/5", label: "User Rating" },
// //   ];

// //   /* Property-type cards. Link target = same /property route + propertyType state you already use */
// //   const typeCards = [
// //     {
// //       title: "Apartments",
// //       sub: "Flats & Luxury Homes",
// //       icon: <FaBuilding />,
// //       img: "/image/apartment.jpg", // <-- CHANGE IMAGE HERE
// //       type: "Buy",
// //     },
// //     {
// //       title: "Independent Houses",
// //       sub: "Villas & Individual Homes",
// //       icon: <FaHome />,
// //       img: "/image/house.jpg", // <-- CHANGE IMAGE HERE
// //       type: "Buy",
// //     },
// //     {
// //       title: "Plots & Land",
// //       sub: "Residential & Commercial",
// //       icon: <FaTree />,
// //       img: "/image/plot.jpg", // <-- CHANGE IMAGE HERE
// //       type: "Plot/Land",
// //     },
// //     {
// //       title: "Commercial",
// //       sub: "Offices, Shops & Spaces",
// //       icon: <FaCity />,
// //       img: "/image/commercial.jpg", // <-- CHANGE IMAGE HERE
// //       type: "Commercial",
// //     },
// //     {
// //       title: "PG & Co-Living",
// //       sub: "PGs, Hostels & Shared Rooms",
// //       icon: <FaBed />,
// //       img: "/image/pg.jpg", // <-- CHANGE IMAGE HERE
// //       type: "PG/Co-living",
// //     },
// //   ];



// //   return (



// //     <>



// //       <div className="w-full bg-[#fdf9f6] font-sans antialiased">
// //         {/* SEO / AEO / GEO : structured data (edit name/description/url if needed) */}
// //         <script
// //           type="application/ld+json"
// //           dangerouslySetInnerHTML={{
// //             __html: JSON.stringify({
// //               "@context": "https://schema.org",
// //               "@graph": [
// //                 {
// //                   "@type": "Organization",
// //                   name: "ZeroBriks",
// //                   description:
// //                     "ZeroBriks is an Indian real estate platform to buy, rent or sell homes, plots and commercial property directly from verified owners with zero brokerage.",
// //                   areaServed: { "@type": "Country", name: "India" },
// //                 },
// //                 {
// //                   "@type": "WebSite",
// //                   name: "ZeroBriks",
// //                   inLanguage: "en-IN",
// //                   description:
// //                     "Buy, rent or sell property in 50+ cities across India directly from verified owners. No brokerage, no middlemen.",
// //                 },
// //               ],
// //             }),
// //           }}
// //         />

// //         {/* ============================================================ */}
// //         {/*  SECTION 1 : HERO                                            */}
// //         {/* ============================================================ */}
// //         <section
// //           aria-labelledby="hero-heading"
// //           className="relative w-full overflow-hidden"
// //         >
// //           {/* Background image  <-- CHANGE HERO IMAGE HERE */}
// //           <div
// //             role="img"
// //             aria-label="Modern home exterior, property listed directly by the owner"
// //             className="absolute inset-0 bg-center bg-cover"
// //             style={{ backgroundImage: "url('/image/modern.jpg')" }}
// //           />
// //           {/* Dark overlay (left side darker so text is readable) */}
// //           <div
// //             aria-hidden="true"
// //             className="absolute inset-0 bg-black/60 lg:bg-gradient-to-r lg:from-black/75 lg:via-black/45 lg:to-black/5"
// //           />

// //           {/* Curved cream bottom edge */}
// //           <div
// //             aria-hidden="true"
// //             className="absolute bottom-0 inset-x-0 h-6 sm:h-9 bg-[#fdf9f6] rounded-t-[50%_100%] z-[1]"
// //           />

// //           <div className="relative z-10 grid items-start gap-4 px-3 pt-4 pb-7 mx-auto max-w-[900px] sm:px-5 md:grid-cols-[250px_minmax(0,1fr)] md:gap-5 lg:px-6 lg:pb-9">
// //             {/* ================= LEFT : SEARCH CARD ================= */}
// //             <div className="relative w-full max-w-[380px] mx-auto md:max-w-none md:mx-0">
// //               {/* gold strip peeking from under the card */}
// //               <div
// //                 aria-hidden="true"
// //                 className="absolute inset-x-3 -bottom-1 h-2.5 rounded-b-lg bg-gradient-to-r from-[#d9a441] to-[#b0701f]"
// //               />

// //               <div
// //                 role="search"
// //                 aria-label="Search properties"
// //                 className="relative p-3 bg-white shadow-2xl rounded-xl"
// //               >
// //                 {/* Tabs (same Links as before) – labels wrap to a new row instead of being cut off */}
// //                 <nav
// //                   aria-label="Property categories"
// //                   className="flex flex-wrap gap-1"
// //                 >
// //                   {propertyTabs.map((tab, i) => (
// //                     <Link
// //                       key={tab.label}
// //                       to={{
// //                         pathname: "/property",
// //                         state: { propertyType: tab.type },
// //                       }}
// //                       className={`flex items-center justify-center grow shrink-0 basis-auto min-h-[28px] px-2.5 py-1 text-[11px] font-medium leading-tight text-center whitespace-nowrap no-underline rounded-md transition hover:no-underline ${i === 0
// //                           ? "bg-[#7a0f2e] text-white"
// //                           : "bg-gray-100 text-gray-700 hover:bg-gray-200"
// //                         }`}
// //                     >
// //                       {tab.label}
// //                     </Link>
// //                   ))}
// //                 </nav>

// //                 <h2 className="mt-3 mb-2 text-[13px] font-semibold text-gray-900">
// //                   Search Properties
// //                 </h2>

// //                 <div className="space-y-1.5">
// //                   {/* 1. Location */}
// //                   <div className="flex items-center h-8 md:h-7 px-2 border border-gray-200 rounded-md focus-within:border-[#7a0f2e]">
// //                     <FiMapPin size={12} className="text-[#7a0f2e] shrink-0" aria-hidden="true" />
// //                     <input
// //                       ref={inputRef}
// //                       type="text"
// //                       id="search"
// //                       aria-label="Search by city, locality or landmark"
// //                       placeholder="Enter city, locality or landmark"
// //                       className="w-full px-2 text-xs md:text-[11px] text-gray-700 bg-transparent outline-none placeholder:text-gray-500"
// //                       value={searchQuery}
// //                       onChange={(e) => setSearchQuery(e.target.value)}
// //                     />
// //                   </div>

// //                   {/* 2. Property type */}
// //                   <div className="relative flex items-center h-8 md:h-7 px-2 border border-gray-200 rounded-md focus-within:border-[#7a0f2e]">
// //                     <RiHomeLine size={12} className="text-[#7a0f2e] shrink-0" aria-hidden="true" />
// //                     <select
// //                       id="type"
// //                       aria-label="Property type"
// //                       className="w-full h-full px-2 text-xs md:text-[11px] text-gray-700 bg-transparent outline-none appearance-none cursor-pointer"
// //                       value={type}
// //                       onChange={(e) => setType(e.target.value)}
// //                     >
// //                       <option value="" disabled>
// //                         Property Type
// //                       </option>
// //                       <option value="Residential">Residential</option>
// //                       <option value="Commercial">Commercial</option>
// //                     </select>
// //                     <FiChevronDown
// //                       size={12}
// //                       aria-hidden="true"
// //                       className="absolute text-gray-500 pointer-events-none right-2"
// //                     />
// //                   </div>

// //                   {/* 3. Budget (optional) */}
// //                   <div className="relative flex items-center h-8 md:h-7 px-2 border border-gray-200 rounded-md focus-within:border-[#7a0f2e]">
// //                     <span
// //                       aria-hidden="true"
// //                       className="flex items-center justify-center w-3 h-3 text-[7px] text-white bg-[#7a0f2e] rounded-full shrink-0"
// //                     >
// //                       <FaRupeeSign />
// //                     </span>
// //                     <select
// //                       id="budget"
// //                       name="budget"
// //                       aria-label="Budget (optional)"
// //                       defaultValue=""
// //                       className="w-full h-full px-2 text-xs md:text-[11px] text-gray-700 bg-transparent outline-none appearance-none cursor-pointer"
// //                     >
// //                       <option value="">Budget (Optional)</option>
// //                       <option value="0-2500000">Under ₹25 Lac</option>
// //                       <option value="2500000-5000000">₹25 Lac – ₹50 Lac</option>
// //                       <option value="5000000-10000000">₹50 Lac – ₹1 Cr</option>
// //                       <option value="10000000-20000000">₹1 Cr – ₹2 Cr</option>
// //                       <option value="20000000-">Above ₹2 Cr</option>
// //                     </select>
// //                     <FiChevronDown
// //                       size={12}
// //                       aria-hidden="true"
// //                       className="absolute text-gray-500 pointer-events-none right-2"
// //                     />
// //                   </div>

// //                   {/* 4. More filters */}
// //                   <button
// //                     type="button"
// //                     className="flex items-center w-full h-8 md:h-7 px-2 text-left border border-gray-200 rounded-md hover:border-[#7a0f2e]"
// //                   >
// //                     <FiSliders size={12} className="text-[#7a0f2e] shrink-0" aria-hidden="true" />
// //                     <span className="flex-1 px-2 text-xs md:text-[11px] text-gray-700">
// //                       More Filters
// //                     </span>
// //                     <FiChevronDown size={12} className="text-gray-500" aria-hidden="true" />
// //                   </button>
// //                 </div>

// //                 {/* Search button */}
// //                 <button
// //                   type="button"
// //                   className="flex items-center justify-center w-full h-9 md:h-8 gap-1.5 mt-2.5 text-xs font-medium text-white transition rounded-md bg-[#7a0f2e] hover:bg-[#5c0a22]"
// //                   onClick={handleSearch}
// //                 >
// //                   <span>Search Properties</span>
// //                   <FaArrowRight size={9} aria-hidden="true" />
// //                 </button>

// //                 {/* Error message */}
// //                 {error && (
// //                   <div className="mt-2 text-center" role="alert">
// //                     <span className="inline-block px-2 py-1 text-[11px] text-white bg-gray-800 rounded">
// //                       {error}
// //                     </span>
// //                   </div>
// //                 )}

// //                 {/* Popular cities */}
// //                 <nav aria-label="Popular cities" className="mt-3">
// //                   <p className="flex items-center gap-1 mb-1.5 text-[11px] font-medium text-gray-700">
// //                     <FaFire className="text-[#7a0f2e]" aria-hidden="true" /> Popular Cities
// //                   </p>
// //                   <div className="flex flex-wrap gap-1">
// //                     {popularCities.slice(0, 5).map((location) => (
// //                       <Link
// //                         key={location}
// //                         to={`/citywiseproperties/${location}`}
// //                         className="px-2.5 py-0.5 text-[11px] text-gray-700 no-underline bg-gray-100 rounded-full hover:bg-[#7a0f2e] hover:text-white hover:no-underline"
// //                       >
// //                         {location}
// //                       </Link>
// //                     ))}
// //                   </div>
// //                 </nav>
// //               </div>
// //             </div>

// //             {/* ================= RIGHT : HEADLINE + STATS ================= */}
// //             <div className="min-w-0 text-white md:pt-1">
// //               <p className="mb-1 text-[11px] font-semibold tracking-[0.14em] text-[#f2b632]">
// //                 WELCOME TO ZEROBRIKS {/* <-- CHANGE BRAND NAME HERE */}
// //               </p>
// //               <h1
// //                 id="hero-heading"
// //                 className="text-[22px] font-bold leading-[1.12] sm:text-[27px] xl:text-[31px] md:max-w-[62%] lg:max-w-none"
// //               >
// //                 Homes.
// //                 <br />
// //                 Investments.
// //                 <br />
// //                 Opportunities.
// //                 <br />
// //                 <span className="text-[#f2b632]">Directly from Owners.</span>
// //               </h1>
// //               <p className="mt-2.5 text-[13px] font-semibold">
// //                 No brokerage. No middlemen.
// //               </p>
// //               <p className="text-xs text-gray-100">
// //                 A smarter way to buy, rent or sell property.
// //               </p>

// //               {/* Feature icons */}
// //               <ul className="flex mt-3.5 overflow-x-auto divide-x list-none md:max-w-[340px] divide-white/20 p-0 m-0">
// //                 {[
// //                   { icon: <FaPercent />, a: "Zero", b: "Brokerage" },
// //                   { icon: <FaShieldAlt />, a: "Verified", b: "Owners" },
// //                   { icon: <FaMagic />, a: "AI Smart", b: "Match" },
// //                   { icon: <FaCamera />, a: "Virtual", b: "Tour" },
// //                   { icon: <FaLock />, a: "Secure &", b: "Transparent" },
// //                 ].map((f) => (
// //                   <li
// //                     key={f.a}
// //                     className="flex flex-col items-center flex-1 min-w-[64px] px-1 text-center"
// //                   >
// //                     <span
// //                       aria-hidden="true"
// //                       className="flex items-center justify-center w-7 h-7 mb-1 text-xs text-white bg-[#7a0f2e] rounded-full ring-1 ring-white/30"
// //                     >
// //                       {f.icon}
// //                     </span>
// //                     <span className="text-[11px] leading-tight">
// //                       {f.a}
// //                       <br />
// //                       {f.b}
// //                     </span>
// //                   </li>
// //                 ))}
// //               </ul>

// //               {/* Stats bar */}
// //               <div className="grid grid-cols-2 mt-4 text-gray-900 border border-white/70 shadow-xl lg:translate-y-5 rounded-xl bg-[#f6ede4]/95 backdrop-blur lg:grid-cols-4 lg:divide-x divide-[#e6d6c6]">
// //                 {[
// //                   {
// //                     icon: <FaHome />,
// //                     tone: "bg-[#fde3c8] text-[#e8730c]",
// //                     value: "50,000+",
// //                     label: "Property Listings",
// //                   },
// //                   {
// //                     icon: <FaUsers />,
// //                     tone: "bg-[#f7dde2] text-[#7a0f2e]",
// //                     value: "10,000+",
// //                     label: "Verified Owners",
// //                   },
// //                   {
// //                     icon: <FaBuilding />,
// //                     tone: "bg-[#f7dde2] text-[#7a0f2e]",
// //                     value: "50+",
// //                     label: "Cities Across India",
// //                   },
// //                   {
// //                     icon: <FaStar />,
// //                     tone: "bg-[#fdf0c9] text-[#e6a817]",
// //                     value: "4.8/5",
// //                     label: "User Rating",
// //                     sub: "Trusted by Thousands",
// //                   },
// //                 ].map((s) => (
// //                   <div key={s.label} className="flex items-center gap-1.5 p-2">
// //                     <span
// //                       aria-hidden="true"
// //                       className={`flex items-center justify-center w-7 h-7 text-sm rounded-full shrink-0 ${s.tone}`}
// //                     >
// //                       {s.icon}
// //                     </span>
// //                     <div className="min-w-0 leading-tight">
// //                       <p className="text-[13px] font-bold">{s.value}</p>
// //                       <p className="text-[11px] text-gray-700 truncate">{s.label}</p>
// //                       {s.sub && (
// //                         <p className="text-[10px] text-gray-600 truncate">{s.sub}</p>
// //                       )}
// //                     </div>
// //                   </div>
// //                 ))}
// //               </div>
// //             </div>

// //             {/* ---- Decorative: gold arc + maroon circle badge (desktop only) ---- */}
// //             <div
// //               aria-hidden="true"
// //               className="absolute hidden xl:block right-[60px] top-3 w-[170px] h-[170px] rounded-full border border-[#f2b632]/70 border-b-transparent border-l-transparent -rotate-12 pointer-events-none"
// //             />
// //             <div
// //               aria-hidden="true"
// //               className="absolute hidden lg:flex flex-col justify-center right-8 top-5 w-[104px] h-[104px] p-3.5 text-white rounded-full shadow-2xl bg-[#7a0f2e]/90 backdrop-blur"
// //             >
// //               <span className="text-[11px]">Your</span>
// //               <span className="text-[11px] leading-snug">Property Journey</span>
// //               <span className="text-[11px] leading-snug">Made Simple.</span>
// //               <span className="w-5 h-[2px] mt-1 bg-[#f2b632]" />
// //             </div>

// //             {/* ---- Decorative: verified owners pill (desktop only) ---- */}
// //             <div className="absolute hidden lg:flex items-center right-5 bottom-[100px] pl-1.5 pr-1 py-0.5 bg-white/95 rounded-full shadow-xl">
// //               <div className="flex -space-x-2">
// //                 {[1, 2, 3].map((n) => (
// //                   <img
// //                     key={n}
// //                     src={`/image/owner-${n}.jpg`}
// //                     alt={`Verified property owner ${n}`}
// //                     width="22"
// //                     height="22"
// //                     loading="lazy"
// //                     className="object-cover w-[22px] h-[22px] bg-gray-300 border-2 border-white rounded-full"
// //                   />
// //                 ))}
// //               </div>
// //               <div className="flex items-center gap-2 py-1 pl-2 pr-1 ml-1.5 text-white rounded-full bg-[#7a0f2e]">



// import React, { useState, useEffect, useRef, useContext } from "react";
// import { Link, useHistory } from "react-router-dom";
// import { FiSearch, FiMapPin, FiChevronDown, FiSliders } from "react-icons/fi";
// import { RiHomeLine } from "react-icons/ri";
// import {
//   FaHome,
//   FaBuilding,
//   FaTree,
//   FaCity,
//   FaBed,
//   FaArrowRight,
//   FaStar,
//   FaUsers,
//   FaFire,
//   FaRupeeSign,
//   FaPercent,
//   FaShieldAlt,
//   FaLock,
//   FaCamera,
//   FaMagic,
// } from "react-icons/fa";
// import { SearchContext } from "./SearchContext";

// const Search = () => {
//   /* ================= LOGIC (UNCHANGED) ================= */
//   const history = useHistory();

//   const { searchCity, setSearchCity } = useContext(SearchContext);
//   const [searchQuery, setSearchQuery] = useState("");
//   const GOOGLE_MAPS_API_KEY = "AIzaSyAt8bj4UACvakZfiSy-0c1o_ivfplm7jEU";
//   const [type, setType] = useState("");
//   const [error, setError] = useState("");
//   const inputRef = useRef(null);

//   const handleCityChange = (e) => {
//     const selectedCity = e.target.value;
//     setSearchCity(selectedCity);
//   };

//   // add by for filter more
//   // --- Add these state hooks ---
//   const [showMoreFilters, setShowMoreFilters] = useState(false);
//   const [selectedBhk, setSelectedBhk] = useState("");
//   const [selectedFurnishing, setSelectedFurnishing] = useState("");
//   const [selectedConstruction, setSelectedConstruction] = useState("");

//   // --- Update your existing handleSearch function ---
//   const handleSearch = () => {
//     if (!searchQuery && !searchCity && !type && !selectedBhk && !selectedFurnishing && !selectedConstruction) {
//       setError("Please enter what you're looking for.");
//       return;
//     }

//     setError("");
//     history.push({
//       pathname: "/searchdashboard",
//       state: {
//         searchCity,
//         searchQuery,
//         type,
//         bhk: selectedBhk,
//         furnishing: selectedFurnishing,
//         constructionStatus: selectedConstruction,
//       },
//     });
//   };
//   useEffect(() => {
//     const loadGoogleMapsScript = () => {
//       if (window.google && window.google.maps) {
//         initAutocomplete();
//         return;
//       }

//       const script = document.createElement("script");
//       script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`;
//       script.async = true;
//       script.defer = true;

//       script.onload = () => {
//         initAutocomplete();
//       };

//       document.body.appendChild(script);
//     };

//     const initAutocomplete = () => {
//       const autocomplete = new window.google.maps.places.Autocomplete(
//         inputRef.current,
//         {
//           types: ["(cities)"],
//           componentRestrictions: { country: "in" },
//         }
//       );

//       autocomplete.addListener("place_changed", () => {
//         const place = autocomplete.getPlace();

//         if (place && place.name) {
//           setSearchQuery(place.name);
//           setSearchCity(place.name);
//         }
//       });
//     };

//     loadGoogleMapsScript();
//   }, []);

//   useEffect(() => {
//     if (!window.google) return;

//     const autocomplete = new window.google.maps.places.Autocomplete(
//       inputRef.current,
//       {
//         types: ["(cities)"],
//         componentRestrictions: { country: "in" },
//       }
//     );

//     autocomplete.addListener("place_changed", () => {
//       const place = autocomplete.getPlace();

//       if (place && place.name) {
//         setSearchQuery(place.name);
//         setSearchCity(place.name);
//       }
//     });
//   }, []);
//   /* ================= END LOGIC ================= */

//   /* UI Data */
//   const propertyTabs = [
//     { label: "Buy", type: "Buy" },
//     { label: "Rent", type: "Rent" },
//     { label: "PG", type: "PG/Co-living" },
//     { label: "Plots/Land", type: "Plot/Land" },
//     { label: "Commercial", type: "Commercial" },
//   ];

//   /* Requested City Array (Using name property as requested) */
//   const popularCities = [
//     { name: "Mumbai", imageUrl: "/image/mumbai.jpg", properties: "0" },
//     { name: "Delhi", imageUrl: "/image/delhi.jpg", properties: "0" },
//     { name: "Bangalore", imageUrl: "/image/banglore.jpg", properties: "0" },
//     { name: "Chennai", imageUrl: "/image/chennai.jpg", properties: "0" },
//     { name: "Hyderabad", imageUrl: "/image/hyderabad.jpg", properties: "0" },
//     { name: "Kolkata", imageUrl: "/image/kolkatta.jpg", properties: "0" },
//     { name: "Pune", imageUrl: "/image/pune.jpg", properties: "0" },
//     { name: "Ahmedabad", imageUrl: "/image/ahemdabad.jpg", properties: "0" },
//   ];

//   const typeCards = [
//     {
//       title: "Apartments",
//       sub: "Flats & Luxury Homes",
//       icon: <FaBuilding />,
//       img: "/image/apartment.jpg",
//       type: "Buy",
//     },
//     {
//       title: "Independent Houses",
//       sub: "Villas & Individual Homes",
//       icon: <FaHome />,
//       img: "/image/house.jpg",
//       type: "Buy",
//     },
//     {
//       title: "Plots & Land",
//       sub: "Residential & Commercial",
//       icon: <FaTree />,
//       img: "/image/plot.jpg",
//       type: "Plot/Land",
//     },
//     {
//       title: "Commercial",
//       sub: "Offices, Shops & Spaces",
//       icon: <FaCity />,
//       img: "/image/commercial.jpg",
//       type: "Commercial",
//     },
//     {
//       title: "PG & Co-Living",
//       sub: "PGs, Hostels & Shared Rooms",
//       icon: <FaBed />,
//       img: "/image/pg.jpg",
//       type: "PG/Co-living",
//     },
//   ];




//   return (
//     <div className="w-full bg-[#fdf9f6] font-sans antialiased overflow-x-hidden">
//       {/* SEO / AEO / GEO : structured data */}
//       <script
//         type="application/ld+json"
//         dangerouslySetInnerHTML={{
//           __html: JSON.stringify({
//             "@context": "https://schema.org",
//             "@graph": [
//               {
//                 "@type": "Organization",
//                 name: "ZeroBriks",
//                 description:
//                   "ZeroBriks is an Indian real estate platform to buy, rent or sell homes, plots and commercial property directly from verified owners with zero brokerage.",
//                 areaServed: { "@type": "Country", name: "India" },
//               },
//               {
//                 "@type": "WebSite",
//                 name: "ZeroBriks",
//                 inLanguage: "en-IN",
//                 description:
//                   "Buy, rent or sell property in 50+ cities across India directly from verified owners. No brokerage, no middlemen.",
//               },
//             ],
//           }),
//         }}
//       />

//       {/* ============================================================ */}
//       {/*  SECTION 1 : HERO                                            */}
//       {/* ============================================================ */}
//       <section
//         aria-labelledby="hero-heading"
//         className="relative w-full overflow-hidden"
//       >
//         {/* Background image */}
//         <div
//           role="img"
//           aria-label="Modern home exterior, property listed directly by the owner"
//           className="absolute inset-0 bg-center bg-cover"
//           style={{ backgroundImage: "url('/image/modern.jpg')" }}
//         />
//         {/* Dark overlay */}
//         <div
//           aria-hidden="true"
//           className="absolute inset-0 bg-black/60 lg:bg-gradient-to-r lg:from-black/80 lg:via-black/40 lg:to-transparent"
//         />

//         {/* Curved cream bottom edge */}
//         <div
//           aria-hidden="true"
//           className="absolute bottom-0 inset-x-0 h-6 sm:h-9 bg-[#fdf9f6] rounded-t-[50%_100%] z-[1]"
//         />

//         <div className="relative z-10 grid items-start gap-4 px-3 pt-4 pb-7 mx-auto max-w-7xl sm:px-5 md:grid-cols-[280px_minmax(0,1fr)] lg:grid-cols-[330px_minmax(0,1fr)] md:gap-6 lg:px-8 lg:pb-12">
//           {/* ================= LEFT : SEARCH CARD ================= */}
//           <div className="relative w-full max-w-[380px] mx-auto md:max-w-none md:mx-0">
//             {/* gold strip peeking from under the card */}
//             <div
//               aria-hidden="true"
//               className="absolute inset-x-3 -bottom-1 h-2.5 rounded-b-lg bg-gradient-to-r from-[#d9a441] to-[#b0701f]"
//             />

//             <div
//               role="search"
//               aria-label="Search properties"
//               className="relative p-3 bg-white shadow-2xl rounded-xl"
//             >
//               {/* Tabs */}
//               <nav
//                 aria-label="Property categories"
//                 className="flex flex-wrap gap-1"
//               >
//                 {propertyTabs.map((tab, i) => (
//                   <Link
//                     key={tab.label}
//                     to={{
//                       pathname: "/property",
//                       state: { propertyType: tab.type },
//                     }}
//                     className={`flex items-center justify-center grow shrink-0 basis-auto min-h-[28px] px-2.5 py-1 text-[11px] font-medium leading-tight text-center whitespace-nowrap no-underline rounded-md transition hover:no-underline ${i === 0
//                       ? "bg-[#7a0f2e] text-white"
//                       : "bg-gray-100 text-gray-700 hover:bg-gray-200"
//                       }`}
//                   >
//                     {tab.label}
//                   </Link>
//                 ))}
//               </nav>

//               <h2 className="mt-3 mb-2 text-[13px] font-semibold text-gray-900">
//                 Search Properties
//               </h2>

//               <div className="space-y-1.5">
//                 {/* 1. Location */}
//                 <div className="flex items-center h-8 md:h-8 px-2 border border-gray-200 rounded-md focus-within:border-[#7a0f2e]">
//                   <FiMapPin size={12} className="text-[#7a0f2e] shrink-0" aria-hidden="true" />
//                   <input
//                     ref={inputRef}
//                     type="text"
//                     id="search"
//                     aria-label="Search by city, locality or landmark"
//                     placeholder="Enter city, locality or landmark"
//                     className="w-full px-2 text-xs md:text-[11px] text-gray-700 bg-transparent outline-none placeholder:text-gray-500"
//                     value={searchQuery}
//                     onChange={(e) => setSearchQuery(e.target.value)}
//                   />
//                 </div>

//                 {/* 2. Property type */}
//                 <div className="relative flex items-center h-8 md:h-8 px-2 border border-gray-200 rounded-md focus-within:border-[#7a0f2e]">
//                   <RiHomeLine size={12} className="text-[#7a0f2e] shrink-0" aria-hidden="true" />
//                   <select
//                     id="type"
//                     aria-label="Property type"
//                     className="w-full h-full px-2 text-xs md:text-[11px] text-gray-700 bg-transparent outline-none appearance-none cursor-pointer"
//                     value={type}
//                     onChange={(e) => setType(e.target.value)}
//                   >
//                     <option value="" disabled>
//                       Property Type
//                     </option>
//                     <option value="Residential">Residential</option>
//                     <option value="Commercial">Commercial</option>
//                   </select>
//                   <FiChevronDown
//                     size={12}
//                     aria-hidden="true"
//                     className="absolute text-gray-500 pointer-events-none right-2"
//                   />
//                 </div>

//                 {/* 3. Budget (optional) */}
//                 <div className="relative flex items-center h-8 md:h-8 px-2 border border-gray-200 rounded-md focus-within:border-[#7a0f2e]">
//                   <span
//                     aria-hidden="true"
//                     className="flex items-center justify-center w-3 h-3 text-[7px] text-white bg-[#7a0f2e] rounded-full shrink-0"
//                   >
//                     <FaRupeeSign />
//                   </span>
//                   <select
//                     id="budget"
//                     name="budget"
//                     aria-label="Budget (optional)"
//                     defaultValue=""
//                     className="w-full h-full px-2 text-xs md:text-[11px] text-gray-700 bg-transparent outline-none appearance-none cursor-pointer"
//                   >
//                     <option value="">Budget (Optional)</option>
//                     <option value="0-2500000">Under ₹25 Lac</option>
//                     <option value="2500000-5000000">₹25 Lac – ₹50 Lac</option>
//                     <option value="5000000-10000000">₹50 Lac – ₹1 Cr</option>
//                     <option value="10000000-20000000">₹1 Cr – ₹2 Cr</option>
//                     <option value="20000000-">Above ₹2 Cr</option>
//                   </select>
//                   <FiChevronDown
//                     size={12}
//                     aria-hidden="true"
//                     className="absolute text-gray-500 pointer-events-none right-2"
//                   />
//                 </div>

//                 {/* 4. More filters */}


//                 {/* 4. More filters */}
//                 <div className="relative w-full">
//                   <button
//                     type="button"
//                     onClick={() => setShowMoreFilters(!showMoreFilters)}
//                     className="flex items-center w-full h-8 md:h-8 px-2 text-left border border-gray-200 rounded-md hover:border-[#7a0f2e] transition bg-white"
//                   >
//                     <FiSliders size={12} className="text-[#7a0f2e] shrink-0" aria-hidden="true" />
//                     <span className="flex-1 px-2 text-xs md:text-[11px] text-gray-700 truncate">
//                       {selectedBhk || selectedFurnishing || selectedConstruction
//                         ? `${selectedBhk ? selectedBhk + " " : ""}${selectedFurnishing ? selectedFurnishing + " " : ""}`
//                         : "More Filters"}
//                     </span>
//                     <FiChevronDown
//                       size={12}
//                       className={`text-gray-500 transition-transform duration-200 ${showMoreFilters ? "rotate-180" : ""}`}
//                       aria-hidden="true"
//                     />
//                   </button>

//                   {/* Filter Options Popover */}
//                   {showMoreFilters && (
//                     <div className="absolute left-0 right-0 z-50 p-3 mt-1 bg-white border border-gray-200 rounded-lg shadow-xl space-y-2.5 text-xs">
//                       {/* BHK Options */}
//                       <div>
//                         <label className="block mb-1 text-[11px] font-semibold text-gray-700">
//                           BHK Configuration
//                         </label>
//                         <div className="flex flex-wrap gap-1">
//                           {["1 BHK", "2 BHK", "3 BHK", "4+ BHK"].map((bhk) => (
//                             <button
//                               key={bhk}
//                               type="button"
//                               onClick={() => setSelectedBhk(selectedBhk === bhk ? "" : bhk)}
//                               className={`px-2 py-0.5 text-[10px] rounded border transition ${selectedBhk === bhk
//                                 ? "bg-[#7a0f2e] text-white border-[#7a0f2e]"
//                                 : "bg-gray-50 text-gray-700 border-gray-200 hover:bg-gray-100"
//                                 }`}
//                             >
//                               {bhk}
//                             </button>
//                           ))}
//                         </div>
//                       </div>

//                       {/* Furnishing Status */}
//                       <div>
//                         <label className="block mb-1 text-[11px] font-semibold text-gray-700">
//                           Furnishing
//                         </label>
//                         <div className="flex flex-wrap gap-1">
//                           {["Fully Furnished", "Semi-Furnished", "Unfurnished"].map((furnish) => (
//                             <button
//                               key={furnish}
//                               type="button"
//                               onClick={() => setSelectedFurnishing(selectedFurnishing === furnish ? "" : furnish)}
//                               className={`px-2 py-0.5 text-[10px] rounded border transition ${selectedFurnishing === furnish
//                                 ? "bg-[#7a0f2e] text-white border-[#7a0f2e]"
//                                 : "bg-gray-50 text-gray-700 border-gray-200 hover:bg-gray-100"
//                                 }`}
//                             >
//                               {furnish}
//                             </button>
//                           ))}
//                         </div>
//                       </div>

//                       {/* Construction Status */}
//                       <div>
//                         <label className="block mb-1 text-[11px] font-semibold text-gray-700">
//                           Construction Status
//                         </label>
//                         <div className="flex flex-wrap gap-1">
//                           {["Ready to Move", "Under Construction"].map((status) => (
//                             <button
//                               key={status}
//                               type="button"
//                               onClick={() => setSelectedConstruction(selectedConstruction === status ? "" : status)}
//                               className={`px-2 py-0.5 text-[10px] rounded border transition ${selectedConstruction === status
//                                 ? "bg-[#7a0f2e] text-white border-[#7a0f2e]"
//                                 : "bg-gray-50 text-gray-700 border-gray-200 hover:bg-gray-100"
//                                 }`}
//                             >
//                               {status}
//                             </button>
//                           ))}
//                         </div>
//                       </div>

//                       {/* Clear Filters Button */}
//                       {(selectedBhk || selectedFurnishing || selectedConstruction) && (
//                         <button
//                           type="button"
//                           onClick={() => {
//                             setSelectedBhk("");
//                             setSelectedFurnishing("");
//                             setSelectedConstruction("");
//                           }}
//                           className="w-full pt-1 text-center text-[10px] text-[#7a0f2e] underline font-medium"
//                         >
//                           Reset Filters
//                         </button>
//                       )}
//                     </div>
//                   )}
//                 </div>


//               </div>

//               {/* Search button */}
//               <button
//                 type="button"
//                 className="flex items-center justify-center w-full h-9 md:h-8 gap-1.5 mt-2.5 text-xs font-medium text-white transition rounded-md bg-[#7a0f2e] hover:bg-[#5c0a22]"
//                 onClick={handleSearch}
//               >
//                 <span>Search Properties</span>
//                 <FaArrowRight size={9} aria-hidden="true" />
//               </button>

//               {/* Error message */}
//               {error && (
//                 <div className="mt-2 text-center" role="alert">
//                   <span className="inline-block px-2 py-1 text-[11px] text-white bg-gray-800 rounded">
//                     {error}
//                   </span>
//                 </div>
//               )}

//               {/* Popular cities */}
//               <nav aria-label="Popular cities" className="mt-3">
//                 <p className="flex items-center gap-1 mb-1.5 text-[11px] font-medium text-gray-700">
//                   <FaFire className="text-[#7a0f2e]" aria-hidden="true" /> Popular Cities
//                 </p>
//                 <div className="flex flex-wrap gap-1">
//                   {popularCities.map((city) => (
//                     <Link
//                       key={city.name}
//                       to={`/citywiseproperties/${city.name}`}
//                       className="px-2.5 py-0.5 text-[11px] text-gray-700 no-underline bg-gray-100 rounded-full hover:bg-[#7a0f2e] hover:text-white hover:no-underline transition"
//                     >
//                       {city.name}
//                     </Link>
//                   ))}
//                 </div>
//               </nav>
//             </div>
//           </div>

//           {/* ================= RIGHT : HEADLINE + STATS ================= */}
//           <div className="min-w-0 text-white md:pt-1">
//             <p className="mb-1 text-[11px] font-semibold tracking-[0.14em] text-[#f2b632]">
//               WELCOME TO ZEROBRIKS
//             </p>
//             <h1
//               id="hero-heading"
//               className="text-[22px] font-bold leading-[1.12] sm:text-[27px] xl:text-[31px] md:max-w-[62%] lg:max-w-none"
//             >
//               Homes.
//               <br />
//               Investments.
//               <br />
//               Opportunities.
//               <br />
//               <span className="text-[#f2b632]">Directly from Owners.</span>
//             </h1>
//             <p className="mt-2.5 text-[13px] font-semibold">
//               No brokerage. No middlemen.
//             </p>
//             <p className="text-xs text-gray-100">
//               A smarter way to buy, rent or sell property.
//             </p>

//             {/* Feature icons */}
//             <ul className="flex mt-3.5 overflow-x-auto divide-x list-none md:max-w-[340px] divide-white/20 p-0 m-0 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
//               {[
//                 { icon: <FaPercent />, a: "Zero", b: "Brokerage" },
//                 { icon: <FaShieldAlt />, a: "Verified", b: "Owners" },
//                 { icon: <FaMagic />, a: "AI Smart", b: "Match" },
//                 { icon: <FaCamera />, a: "Virtual", b: "Tour" },
//                 { icon: <FaLock />, a: "Secure &", b: "Transparent" },
//               ].map((f) => (
//                 <li
//                   key={f.a}
//                   className="flex flex-col items-center flex-1 min-w-[64px] px-1 text-center"
//                 >
//                   <span
//                     aria-hidden="true"
//                     className="flex items-center justify-center w-7 h-7 mb-1 text-xs text-white bg-[#7a0f2e] rounded-full ring-1 ring-white/30"
//                   >
//                     {f.icon}
//                   </span>
//                   <span className="text-[11px] leading-tight">
//                     {f.a}
//                     <br />
//                     {f.b}
//                   </span>
//                 </li>
//               ))}
//             </ul>

//             {/* Stats bar */}
//             <div className="grid grid-cols-2 mt-4 text-gray-900 border border-white/70 shadow-xl lg:translate-y-5 rounded-xl bg-[#f6ede4]/95 backdrop-blur lg:grid-cols-4 divide-[#e6d6c6] [&>*:nth-child(odd)]:border-r [&>*:nth-child(-n+2)]:border-b lg:[&>*]:border-b-0 lg:[&>*]:border-r lg:[&>*:last-child]:border-r-0 [&>*]:border-[#e6d6c6]">
//               {[
//                 {
//                   icon: <FaHome />,
//                   tone: "bg-[#fde3c8] text-[#e8730c]",
//                   value: "50,000+",
//                   label: "Property Listings",
//                   sub: "Across India",
//                 },
//                 {
//                   icon: <FaUsers />,
//                   tone: "bg-[#f7dde2] text-[#7a0f2e]",
//                   value: "10,000+",
//                   label: "Verified Owners",
//                   sub: "Genuine & Trusted",
//                 },
//                 {
//                   icon: <FaBuilding />,
//                   tone: "bg-[#f7dde2] text-[#7a0f2e]",
//                   value: "50+",
//                   label: "Cities Across India",
//                   sub: "And Growing",
//                 },
//                 {
//                   icon: <FaStar />,
//                   tone: "bg-[#fdf0c9] text-[#e6a817]",
//                   value: "4.8/5",
//                   label: "User Rating",
//                   sub: "Trusted by Thousands",
//                 },
//               ].map((s) => (
//                 <div
//                   key={s.label}
//                   className="flex items-center justify-center gap-2 px-2 py-3 min-h-[64px]"
//                 >
//                   <span
//                     aria-hidden="true"
//                     className={`flex items-center justify-center w-8 h-8 text-sm rounded-full shrink-0 ${s.tone}`}
//                   >
//                     {s.icon}
//                   </span>
//                   <div className="flex-1 min-w-0 leading-tight text-left">
//                     <p className="text-[13px] font-bold">{s.value}</p>
//                     <p className="text-[11px] text-gray-700 truncate">{s.label}</p>
//                     <p className="text-[10px] mb-2   text-gray-600 truncate">{s.sub}</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* ---- Decorative: gold arc + maroon circle badge (desktop only) ---- */}
//           <div
//             aria-hidden="true"
//             className="absolute hidden lg:block right-8 top-3 w-[170px] h-[170px] pointer-events-none"
//           >
//             {/* Outer decorative circle */}
//             <div className="absolute inset-0 rounded-full border border-[#f2b632]/70 border-b-transparent border-l-transparent -rotate-12" />

//             {/* Centered inner circle */}
//             <div className="absolute inset-0 m-auto flex flex-col items-center justify-center w-[160px] h-[160px] p-3 text-white rounded-full shadow-2xl bg-[#7a0f2e]/25 backdrop-blur-sm">
//               <span className="text-[15px]">Your</span>
//               <span className="text-[15px] leading-snug">Property Journey</span>
//               <span className="text-[15px] leading-snug">Made Simple.</span>
//               <span className="w-5 h-[2px] mt-1 bg-[#f2b632]" />
//             </div>
//           </div>




//           {/* ---- Decorative: verified owners pill (desktop only) ---- */}
//           <div className="absolute hidden lg:flex items-center right-5 bottom-[200px] p-1 bg-white/95 rounded-full shadow-xl">
//             <div className="flex items-center -space-x-2 pl-0.5">
//               {[1, 2, 3].map((n) => (
//                 <img
//                   key={n}
//                   src="/image/pp.png"
//                   alt={`Verified property owner ${n}`}
//                   width="25"
//                   height="25"
//                   loading="lazy"
//                   className="object-cover w-[25px] h-[25px] bg-gray-300 border-2 border-white rounded-full"
//                 />
//               ))}
//             </div>

//             <div className="flex items-center gap-2 py-1 pl-3 pr-1.5 ml-2 text-white rounded-full bg-[#7a0f2e]">
//               <div className="leading-tight text-left">
//                 <p className="text-[10px] font-bold">10,000+</p>
//                 <p className="text-[10px] whitespace-nowrap">Verified Property Owners</p>
//               </div>
//               <span
//                 aria-hidden="true"
//                 className="flex items-center justify-center w-5 h-5 text-[9px] border border-[#f2b632] rounded-full text-[#f2b632] shrink-0"
//               >
//                 <FaArrowRight />
//               </span>
//             </div>
//           </div>


//         </div>


//       </section>

//       {/* ============================================================ */}
//       {/*  SECTION 2 : DISCOVER PROPERTIES                             */}
//       {/* ============================================================ */}
//       <section
//         aria-labelledby="discover-heading"
//         className="bg-gradient-to-b from-[#fdf9f6] via-[#fdf9f6] to-[#f7dcc3]"
//       >
//         <div className="px-3 pt-4 pb-20 mx-auto max-w-7xl sm:px-5 lg:px-8 lg:pt-8">
//           <div className="flex flex-col gap-2 mb-3.5 md:flex-row md:items-end md:justify-between">
//             <div>
//               <p className="mb-1 text-[11px] font-semibold tracking-[0.14em] text-[#b0701f]">
//                 EXPLORE BY PROPERTY TYPE
//               </p>
//               <h2
//                 id="discover-heading"
//                 className="text-lg font-bold text-[#14213d] sm:text-xl"
//               >
//                 Discover Properties{" "}
//                 <span className="text-[#7a0f2e]">Across India</span>
//               </h2>
//             </div>

//             <div className="flex flex-col gap-2 md:flex-row md:items-center md:gap-5">
//               <p className="max-w-[300px] text-xs leading-relaxed text-gray-700">
//                 From dream homes to high-value investments, explore verified
//                 properties directly from owners in top cities across India.
//               </p>
//               <Link
//                 to={{ pathname: "/property", state: { propertyType: "Buy" } }}
//                 className="inline-flex items-center self-start gap-1.5 px-3.5 py-1 text-[11px] font-medium text-[#7a0f2e] no-underline bg-white border border-[#7a0f2e] rounded-full whitespace-nowrap hover:bg-[#7a0f2e] hover:text-[#14213d] hover:no-underline hover:border-[#7a0f2e] transition"
//               >
//                 View All Properties <FaArrowRight size={8} aria-hidden="true" />
//               </Link>
//             </div>
//           </div>

//           <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-5">
//             {typeCards.map((c) => (
//               <Link
//                 key={c.title}
//                 to={{ pathname: "/property", state: { propertyType: c.type } }}
//                 aria-label={`${c.title} – ${c.sub}`}
//                 className="relative block overflow-hidden no-underline transition shadow-md group rounded-lg hover:shadow-xl hover:-translate-y-1 hover:no-underline"
//               >
//                 <img
//                   src={c.img}
//                   alt={`${c.title}: ${c.sub}`}
//                   className="object-cover w-full h-[116px] sm:h-[130px]"
//                   loading="lazy"
//                   decoding="async"
//                 />
//                 {/* floating white info box */}
//                 <div className="absolute flex items-center gap-1.5 p-1.5 bg-white shadow-lg inset-x-1.5 bottom-1.5 rounded-md">
//                   <span
//                     aria-hidden="true"
//                     className="flex items-center justify-center w-6 h-6 text-xs text-[#7a0f2e] rounded-full bg-[#f9e4e8] shrink-0"
//                   >
//                     {c.icon}
//                   </span>
//                   <span className="flex-1 min-w-0 leading-tight">
//                     <span className="block text-xs font-semibold text-[#14213d] truncate">
//                       {c.title}
//                     </span>
//                     <span className="block text-[11px] text-gray-600 truncate">
//                       {c.sub}
//                     </span>
//                   </span>
//                   <span
//                     aria-hidden="true"
//                     className="flex items-center justify-center w-4 h-4 text-[7px] text-[#b0701f] border border-[#c8962e] rounded-full shrink-0"
//                   >
//                     <FaArrowRight />
//                   </span>
//                 </div>
//               </Link>
//             ))}
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Search;
import React, { useState, useEffect, useRef, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import { FiSearch, FiMapPin, FiChevronDown, FiSliders, FiCrosshair, FiMic, FiClock } from "react-icons/fi";
import { RiHomeLine } from "react-icons/ri";
import {
  FaHome,
  FaBuilding,
  FaTree,
  FaCity,
  FaBed,
  FaArrowRight,
  FaStar,
  FaUsers,
  FaFire,
  FaRupeeSign,
  FaPercent,
  FaShieldAlt,
  FaLock,
  FaCamera,
  FaMagic,
  FaStore,
  FaMap,
  FaLayerGroup,
} from "react-icons/fa";
import { SearchContext } from "./SearchContext";

/* ================= SEARCH CONFIG ================= */
const POST_PROPERTY_PATH = "/postproperty"; // TODO: set this to your real "Post Property" route
const RECENT_KEY = "zb_recent_searches";
const MAX_LOCATIONS = 3;

const BUY_TYPES = ["Flat/Apartment", "Home/Villa", "Service Apartment", "Farmhouse", "Plot/Land", "Builder Floor", "1RK/Studio Apartment"];
const RENT_TYPES = ["Flat/Apartment", "Builder Floor", "1RK/Studio Apartment", "Independent House/Villa", "Service Apartment", "Farmhouse"];
const PG_TYPES = ["Flat/Apartment", "Builder Floor", "1RK/Studio Apartment", "Independent House/Villa", "Service Apartment"];
const COMMERCIAL_BUY_TYPES = [
  "Ready to move office space", "Bare shell office space", "Ware House", "Factory", "Hotel/Resorts",
  "Others", "Plot/Land", "Cold Storage", "Manufacturing", "Guest-House/Banquet-Halls", "Retail",
];
const COMMERCIAL_LEASE_TYPES = ["Office Space", "Retail Shops/Showrooms", "Other Commercial spaces", "Plot/Land"];
const PLOT_TYPES = ["Commercial Land/Inst. Land", "Industrial Lands/Plots", "Agricultural/Farm Land"];

const BUY_BUDGETS = [
  { label: "Under ₹25 Lac", value: "0-2500000" },
  { label: "₹25 Lac – ₹50 Lac", value: "2500000-5000000" },
  { label: "₹50 Lac – ₹1 Cr", value: "5000000-10000000" },
  { label: "₹1 Cr – ₹2 Cr", value: "10000000-20000000" },
  { label: "Above ₹2 Cr", value: "20000000-" },
];
const RENT_BUDGETS = [
  { label: "Under ₹10,000", value: "0-10000" },
  { label: "₹10,000 – ₹25,000", value: "10000-25000" },
  { label: "₹25,000 – ₹50,000", value: "25000-50000" },
  { label: "₹50,000 – ₹1 Lac", value: "50000-100000" },
  { label: "Above ₹1 Lac", value: "100000-" },
];
const PG_BUDGETS = [
  { label: "Under ₹5,000", value: "0-5000" },
  { label: "₹5,000 – ₹10,000", value: "5000-10000" },
  { label: "₹10,000 – ₹20,000", value: "10000-20000" },
  { label: "Above ₹20,000", value: "20000-" },
];

// One entry per tab. `category` matches the values your listing page already uses.
const TABS = [
  { id: "Buy", label: "Buy", category: "Buy", building: "Residential", all: "All Residential", types: BUY_TYPES, budgets: BUY_BUDGETS, example: "Flats for sale in Hyderabad" },
  { id: "Rent", label: "Rent", category: "Rent", building: "Residential", all: "All Residential", types: RENT_TYPES, budgets: RENT_BUDGETS, monthly: true, example: "Flats for rent in sector 77 Noida" },
  { id: "PG/Co-living", label: "PG", category: "PG/Co-living", building: "Residential", all: "All PG types", types: PG_TYPES, budgets: PG_BUDGETS, monthly: true, example: "PG in sector 74 Noida" },
  { id: "Commercial", label: "Commercial", category: "Commercial", building: "Commercial", all: "All Commercial", types: COMMERCIAL_BUY_TYPES, budgets: BUY_BUDGETS, hasMode: true, example: "Office space in Baner" },
  { id: "Plot/Land", label: "Plots/Land", category: "Plot/Land", building: "", all: "All Plot Types", types: PLOT_TYPES, budgets: BUY_BUDGETS, example: "Plots in Wakad" },

];

const readRecent = () => {
  try {
    return JSON.parse(localStorage.getItem(RECENT_KEY)) || [];
  } catch {
    return [];
  }
};
const saveRecent = (entry) => {
  try {
    const list = [entry, ...readRecent().filter((r) => r.label !== entry.label)].slice(0, 6);
    localStorage.setItem(RECENT_KEY, JSON.stringify(list));
    return list;
  } catch {
    return [];
  }
};

// Turns the form values into the router state your results page receives.
const buildState = (p) => {
  const t = TABS.find((x) => x.id === p.tab) || TABS[0];
  const lease = t.hasMode && p.mode === "Lease";
  const joined = p.locations.join(", ");
  const [min, max] = (p.budget || "").split("-");
  return {
    searchCity: joined,
    searchQuery: joined,
    propertyType: t.hasMode ? (lease ? "Commercial Lease" : "Commercial Buy") : t.category,
    buildingType: t.building,
    type: t.building, // kept so existing code reading `type` still works
    propertyTypes: p.types,
    minPrice: min && min !== "0" ? min : "",
    maxPrice: max || "",
    bhk: p.bhk,
    furnishing: p.furnishing,
    constructionStatus: t.construction || p.construction,
  };
};

const Search = () => {
  /* ================= LOGIC ================= */
  const history = useHistory();
  const { searchCity, setSearchCity } = useContext(SearchContext);
  const GOOGLE_MAPS_API_KEY = "AIzaSyAt8bj4UACvakZfiSy-0c1o_ivfplm7jEU";

  const [searchQuery, setSearchQuery] = useState("");
  const [error, setError] = useState("");
  const inputRef = useRef(null);
  const recognitionRef = useRef(null);
  const addLocationRef = useRef(() => {});

  // Up to 3 locations
  const [selectedLocations, setSelectedLocations] = useState(
    searchCity
      ? Array.isArray(searchCity)
        ? searchCity
        : String(searchCity).split(",").map((s) => s.trim()).filter(Boolean)
      : []
  );

  // Tab + dependent options
  const [selectedTab, setSelectedTab] = useState("Buy");
  const [commercialMode, setCommercialMode] = useState("Buy"); // Buy | Lease (Commercial tab only)
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [budget, setBudget] = useState("");

  // More filters
  const [showMoreFilters, setShowMoreFilters] = useState(false);
  const [selectedBhk, setSelectedBhk] = useState("");
  const [selectedFurnishing, setSelectedFurnishing] = useState("");
  const [selectedConstruction, setSelectedConstruction] = useState("");

  const [openDd, setOpenDd] = useState(null); // "types" | null
  const [locating, setLocating] = useState(false);
  const [listening, setListening] = useState(false);
  const [recent, setRecent] = useState(readRecent);
  const [showAllRecent, setShowAllRecent] = useState(false);

  /* ---- values that depend on the selected tab ---- */
  const tab = TABS.find((t) => t.id === selectedTab) || TABS[0];
  const lease = tab.hasMode && commercialMode === "Lease";
  const typeOptions = lease ? COMMERCIAL_LEASE_TYPES : tab.types;
  const isMonthly = tab.monthly || lease;
  const budgetOptions = lease ? RENT_BUDGETS : tab.budgets;
  const showBhk = selectedTab !== "Commercial" && selectedTab !== "Plot/Land";
  const showFurnishing = selectedTab !== "Plot/Land";
  const showConstruction = selectedTab !== "New Launch" && selectedTab !== "Plot/Land";
  const tabText = (id, mode) => (id === "Commercial" ? `Commercial ${mode}` : (TABS.find((t) => t.id === id) || TABS[0]).label);

  const selectTab = (t) => {
    if (t.action === "post") {
      history.push(POST_PROPERTY_PATH);
      return;
    }
    setSelectedTab(t.id);
    setCommercialMode("Buy");
    setSelectedTypes([]);
    setBudget("");
    setOpenDd(null);
    setError("");
    if (t.id === "Commercial" || t.id === "Plot/Land") setSelectedBhk("");
    if (t.id === "Plot/Land") setSelectedFurnishing("");
    setSelectedConstruction("");
  };

  const changeMode = (mode) => {
    setCommercialMode(mode);
    setSelectedTypes([]);
    setBudget("");
  };

  const toggleType = (opt) =>
    setSelectedTypes((prev) => (prev.includes(opt) ? prev.filter((x) => x !== opt) : [...prev, opt]));

  /* ---- locations ---- */
  const addLocation = (locName) => {
    const trimmed = locName.trim();
    if (!trimmed) return;
    if (selectedLocations.includes(trimmed)) {
      setSearchQuery("");
      return;
    }
    if (selectedLocations.length >= MAX_LOCATIONS) {
      setError("You can select a maximum of 3 locations.");
      return;
    }
    setError("");
    const updated = [...selectedLocations, trimmed];
    setSelectedLocations(updated);
    setSearchCity(updated.join(", "));
    setSearchQuery("");
  };
  addLocationRef.current = addLocation;

  const removeLocation = (locToRemove) => {
    const updated = selectedLocations.filter((loc) => loc !== locToRemove);
    setSelectedLocations(updated);
    setSearchCity(updated.join(", "));
    setError("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (searchQuery.trim()) addLocation(searchQuery.trim());
      else handleSearch();
    }
  };

  /* ---- "use my location" ---- */
  const handleLocate = () => {
    if (!navigator.geolocation) {
      setError("Location isn't supported on this device.");
      return;
    }
    setLocating(true);
    setError("");
    const finish = (city) => {
      setLocating(false);
      if (city) addLocationRef.current(city);
      else setError("Couldn't work out your city. Please type it in.");
    };
    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        if (!window.google || !window.google.maps) return finish("");
        new window.google.maps.Geocoder().geocode(
          { location: { lat: coords.latitude, lng: coords.longitude } },
          (results, status) => {
            if (status !== "OK" || !results || !results.length) return finish("");
            const comps = results.flatMap((r) => r.address_components);
            const pick = (type) => (comps.find((c) => c.types.includes(type)) || {}).long_name;
            finish(pick("locality") || pick("administrative_area_level_2") || pick("administrative_area_level_1"));
          }
        );
      },
      (err) => {
        setLocating(false);
        setError(
          err.code === 1
            ? "Location permission denied. Allow it in your browser to use this."
            : "Couldn't get your location. Please try again."
        );
      },
      { timeout: 8000 }
    );
  };

  /* ---- voice search ---- */
  const handleVoice = () => {
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) {
      setError("Voice search isn't supported in this browser. Try Chrome.");
      return;
    }
    if (listening) {
      recognitionRef.current && recognitionRef.current.stop();
      return;
    }
    setError("");
    const rec = new SR();
    rec.lang = "en-IN";
    rec.interimResults = false;
    rec.maxAlternatives = 1;
    rec.onstart = () => setListening(true);
    rec.onend = () => setListening(false);
    rec.onerror = (e) => {
      setListening(false);
      setError(e.error === "not-allowed" ? "Microphone permission denied." : "Couldn't hear that. Please try again.");
    };
    rec.onresult = (e) => {
      const said = e.results[0][0].transcript.replace(/[.,]$/, "").trim();
      const city = popularCities.find((c) => said.toLowerCase().includes(c.name.toLowerCase()));
      if (city) addLocationRef.current(city.name);
      else setSearchQuery(said);
    };
    recognitionRef.current = rec;
    rec.start();
  };

  /* ---- search + recent searches ---- */
  const handleSearch = () => {
    const locations = [...selectedLocations];
    const typed = searchQuery.trim();
    if (typed && !locations.includes(typed) && locations.length < MAX_LOCATIONS) locations.push(typed);

    const hasFilters = selectedTypes.length || budget || selectedBhk || selectedFurnishing || selectedConstruction;
    if (!locations.length && !hasFilters) {
      setError("Please enter what you're looking for.");
      return;
    }

    setError("");
    const params = {
      tab: selectedTab,
      mode: commercialMode,
      locations,
      types: selectedTypes,
      budget,
      bhk: selectedBhk,
      furnishing: selectedFurnishing,
      construction: selectedConstruction,
    };
    setSelectedLocations(locations);
    setSearchCity(locations.join(", "));
    setSearchQuery("");
    if (locations.length) {
      setRecent(saveRecent({ ...params, label: `${tabText(selectedTab, commercialMode)} in ${locations.join(", ")}` }));
    }
    history.push({ pathname: "/searchdashboard", state: buildState(params) });
  };

  const runRecent = (r) => {
    setSelectedTab(r.tab);
    setCommercialMode(r.mode);
    setSelectedTypes(r.types);
    setBudget(r.budget);
    setSelectedBhk(r.bhk);
    setSelectedFurnishing(r.furnishing);
    setSelectedConstruction(r.construction);
    setSelectedLocations(r.locations);
    setSearchCity(r.locations.join(", "));
    setRecent(saveRecent(r));
    history.push({ pathname: "/searchdashboard", state: buildState(r) });
  };

  const clearRecent = () => {
    try {
      localStorage.removeItem(RECENT_KEY);
    } catch {}
    setRecent([]);
    setShowAllRecent(false);
  };

  /* ---- Google Places autocomplete (loads the script once) ---- */
  const canAddMore = selectedLocations.length < MAX_LOCATIONS;
  useEffect(() => {
    if (!canAddMore) return undefined;

    const initAutocomplete = () => {
      if (!inputRef.current || !window.google || !window.google.maps || !window.google.maps.places) return;
      const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
        types: ["(cities)"],
        componentRestrictions: { country: "in" },
      });
      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (place && place.name) addLocationRef.current(place.name);
      });
    };

    if (window.google && window.google.maps && window.google.maps.places) {
      initAutocomplete();
      return undefined;
    }

    let script = document.querySelector("script[data-gmaps]");
    if (!script) {
      script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`;
      script.async = true;
      script.defer = true;
      script.setAttribute("data-gmaps", "1");
      document.body.appendChild(script);
    }
    script.addEventListener("load", initAutocomplete);
    return () => script.removeEventListener("load", initAutocomplete);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canAddMore]);

  /* ---- close dropdowns on outside click, stop mic on unmount ---- */
  useEffect(() => {
    const close = (e) => {
      if (!e.target.closest("[data-dd]")) {
        setOpenDd(null);
        setShowMoreFilters(false);
      }
    };
    document.addEventListener("mousedown", close);
    return () => {
      document.removeEventListener("mousedown", close);
      if (recognitionRef.current) recognitionRef.current.abort();
    };
  }, []);

  /* ================= END LOGIC ================= */

  /* UI Data */

  const popularCities = [
    { name: "Mumbai", imageUrl: "/image/mumbai.jpg", properties: "0" },
    { name: "Delhi", imageUrl: "/image/delhi.jpg", properties: "0" },
    { name: "Bengaluru", imageUrl: "/image/bengaluru.jpg", properties: "0" },
    { name: "Chennai", imageUrl: "/image/chennai.jpg", properties: "0" },
    { name: "Hyderabad", imageUrl: "/image/hyderabad.jpg", properties: "0" },
    { name: "Kolkata", imageUrl: "/image/kolkata.jpg", properties: "0" },
    { name: "Pune", imageUrl: "/image/pune.jpg", properties: "0" },
    { name: "Ahmedabad", imageUrl: "/image/ahmedabad.jpg", properties: "0" },
  ];

  const typeCards = [
    {
      title: "Apartments",
      sub: "Flats & Luxury Homes",
      icon: <FaBuilding />,
      img: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&w=600&q=80",
      type: "Buy",
    },
    {
      title: "Independent Houses",
      sub: "Villas & Individual Homes",
      icon: <FaHome />,
      img: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&w=600&q=80",
      type: "Buy",
    },
    {
      title: "Plots & Land",
      sub: "Residential & Commercial",
      icon: <FaTree />,
      img: "https://images.unsplash.com/photo-1592595896616-c37162298647?auto=format&fit=crop&w=600&q=80",
      type: "Plot/Land",
    },
    {
      title: "Commercial",
      sub: "Offices, Shops & Spaces",
      icon: <FaCity />,
      img: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=600&q=80",
      type: "Commercial",
    },
    {
      title: "PG & Co-Living",
      sub: "PGs, Hostels & Shared Rooms",
      icon: <FaBed />,
      img: "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?auto=format&fit=crop&w=600&q=80",
      type: "PG/Co-living",
    },
  ];
  return (
    <div className="w-full bg-[#fdf9f6] font-sans antialiased overflow-x-hidden">
      {/* SEO / AEO / GEO : structured data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Organization",
                name: "ZeroBriks",
                description:
                  "ZeroBriks is an Indian real estate platform to buy, rent or sell homes, plots and commercial property directly from verified owners with zero brokerage.",
                areaServed: { "@type": "Country", name: "India" },
              },
              {
                "@type": "WebSite",
                name: "ZeroBriks",
                inLanguage: "en-IN",
                description:
                  "Buy, rent or sell property in 50+ cities across India directly from verified owners. No brokerage, no middlemen.",
              },
            ],
          }),
        }}
      />

      {/* ============================================================ */}
      {/*  SECTION 1 : HERO                                            */}
      {/* ============================================================ */}
      <section
        aria-labelledby="hero-heading"
        className="relative w-full overflow-hidden"
      >
        {/* Background image */}
        <div
          role="img"
          aria-label="Modern home exterior, property listed directly by the owner"
          className="absolute inset-0 bg-center bg-cover"
          style={{ backgroundImage: "url('/image/modern.jpg')" }}
        />
        {/* Dark overlay */}
        <div
          aria-hidden="true"
          className="absolute inset-0 bg-black/60 lg:bg-gradient-to-r lg:from-black/80 lg:via-black/40 lg:to-transparent"
        />

        {/* Curved cream bottom edge */}
        <div
          aria-hidden="true"
          className="absolute bottom-0 inset-x-0 h-6 sm:h-9 bg-[#fdf9f6] rounded-t-[50%_100%] z-[1]"
        />

        <div className="relative z-10 grid items-start gap-4 px-3 pt-4 pb-7 mx-auto max-w-7xl sm:px-5 md:grid-cols-[280px_minmax(0,1fr)] lg:grid-cols-[330px_minmax(0,1fr)] md:gap-6 lg:px-8 lg:pb-12">
          {/* ================= LEFT : SEARCH CARD ================= */}
          <div className="relative w-full max-w-[380px] mx-auto md:max-w-none md:mx-0">
            {/* gold strip peeking from under the card */}
            <div
              aria-hidden="true"
              className="absolute inset-x-3 -bottom-1 h-2.5 rounded-b-lg bg-gradient-to-r from-[#d9a441] to-[#b0701f]"
            />

            <div
              role="search"
              aria-label="Search properties"
              className="relative p-3 bg-white shadow-2xl rounded-xl"
            >
              {/* Tabs */}

             
              <nav
                aria-label="Property categories"
                className="flex gap-1 pb-1 overflow-x-auto scrollbar-hide"
              >
                {TABS.map((t) => {
                  const active = selectedTab === t.id;
                  return (
                    <button
                      key={t.id}
                      type="button"
                      onClick={() => selectTab(t)}
                      aria-pressed={active}
                      className={`relative flex items-center justify-center gap-1 grow shrink-0 basis-auto min-h-[28px] px-2.5 py-1 text-[11px] font-medium leading-tight whitespace-nowrap rounded-md transition ${
                        active
                          ? "bg-[#7a0f2e] text-white"
                          : t.free
                            ? "bg-white text-[#7a0f2e] border border-[#7a0f2e]/30 hover:bg-[#7a0f2e]/5"
                            : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                      }`}
                    >
                      {t.label}
                      {t.dot && (
                        <span aria-hidden="true" className="absolute top-0.5 right-0.5 w-1.5 h-1.5 bg-red-500 rounded-full" />
                      )}
                      {t.free && (
                        <span className="px-1 text-[8px] font-bold text-white bg-green-600 rounded">FREE</span>
                      )}
                    </button>
                  );
                })}
              </nav>


              <h2 className="mt-3 mb-2 text-[13px] font-semibold text-gray-900">
                Search Properties
              </h2>

              <div className="space-y-1.5">
                {/* 1. Multi-Location Input Container */}
                <div className="flex flex-wrap items-center gap-1 min-h-[32px] px-2 py-1 border border-gray-200 rounded-md focus-within:border-[#7a0f2e] bg-white">
                  <FiMapPin size={12} className="text-[#7a0f2e] shrink-0 mt-0.5" aria-hidden="true" />

                  {/* Selected Location Chips */}
                  {selectedLocations.map((loc) => (
                    <span
                      key={loc}
                      className="inline-flex items-center gap-1 px-1.5 py-0.5 text-[10px] font-medium text-[#7a0f2e] bg-[#7a0f2e]/10 rounded"
                    >
                      {loc}
                      <button
                        type="button"
                        onClick={() => removeLocation(loc)}
                        className="text-[#7a0f2e] hover:text-red-700 font-bold ml-0.5 focus:outline-none"
                        aria-label={`Remove ${loc}`}
                      >
                        ×
                      </button>
                    </span>
                  ))}

                  {/* Input for adding up to 3 locations */}
                  {selectedLocations.length < 3 && (
                    <input
                      ref={inputRef}
                      type="text"
                      id="search"
                      aria-label="Search by city, locality or landmark"
                      placeholder={selectedLocations.length === 0 ? `Search "${tab.example}"` : "Add another location..."}
                      className="flex-1 min-w-[100px] px-1 text-xs md:text-[11px] text-gray-700 bg-transparent outline-none placeholder:text-gray-500"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      onKeyDown={handleKeyDown}
                    />
                  )}

                  {/* Use my location + voice search */}
                  <div className="flex items-center gap-1 ml-auto shrink-0">
                    <button
                      type="button"
                      onClick={handleLocate}
                      disabled={locating}
                      aria-label="Use my current location"
                      title="Use my current location"
                      className={`flex items-center justify-center w-5 h-5 rounded-full bg-[#7a0f2e]/10 text-[#7a0f2e] hover:bg-[#7a0f2e]/20 transition ${locating ? "animate-pulse" : ""}`}
                    >
                      <FiCrosshair size={11} aria-hidden="true" />
                    </button>
                    <button
                      type="button"
                      onClick={handleVoice}
                      aria-label={listening ? "Stop voice search" : "Search by voice"}
                      title={listening ? "Listening… tap to stop" : "Search by voice"}
                      className={`flex items-center justify-center w-5 h-5 rounded-full transition ${listening ? "bg-red-500 text-white animate-pulse" : "bg-[#7a0f2e]/10 text-[#7a0f2e] hover:bg-[#7a0f2e]/20"}`}
                    >
                      <FiMic size={11} aria-hidden="true" />
                    </button>
                  </div>
                </div>

                {/* 2. Property type (changes with the selected tab) */}
                <div className={tab.hasMode ? "grid grid-cols-[84px_minmax(0,1fr)] gap-1.5" : ""}>
                  {tab.hasMode && (
                    <div className="relative flex items-center h-8 px-2 border border-gray-200 rounded-md focus-within:border-[#7a0f2e]">
                      <select
                        aria-label="Buy or lease"
                        value={commercialMode}
                        onChange={(e) => changeMode(e.target.value)}
                        className="w-full h-full text-xs md:text-[11px] text-gray-700 bg-transparent outline-none appearance-none cursor-pointer"
                      >
                        <option value="Buy">Buy</option>
                        <option value="Lease">Lease</option>
                      </select>
                      <FiChevronDown size={12} aria-hidden="true" className="absolute text-gray-500 pointer-events-none right-2" />
                    </div>
                  )}

                  <div className="relative" data-dd>
                    <button
                      type="button"
                      aria-haspopup="listbox"
                      aria-expanded={openDd === "types"}
                      onClick={() => {
                        setOpenDd(openDd === "types" ? null : "types");
                        setShowMoreFilters(false);
                      }}
                      className="flex items-center w-full h-8 px-2 text-left bg-white border border-gray-200 rounded-md hover:border-[#7a0f2e] transition"
                    >
                      <RiHomeLine size={12} className="text-[#7a0f2e] shrink-0" aria-hidden="true" />
                      <span className="flex-1 px-2 text-xs md:text-[11px] text-gray-700 truncate">
                        {selectedTypes.length === 0
                          ? tab.all
                          : selectedTypes.length === 1
                            ? selectedTypes[0]
                            : `${selectedTypes.length} types selected`}
                      </span>
                      <FiChevronDown
                        size={12}
                        aria-hidden="true"
                        className={`text-gray-500 transition-transform duration-200 ${openDd === "types" ? "rotate-180" : ""}`}
                      />
                    </button>

                    {openDd === "types" && (
                      <div role="listbox" className="absolute left-0 right-0 z-50 mt-1 overflow-y-auto bg-white border border-gray-200 rounded-lg shadow-xl max-h-56">
                        {typeOptions.map((opt) => (
                          <label key={opt} className="flex items-center gap-2 px-3 py-1.5 text-xs cursor-pointer hover:bg-[#7a0f2e]/5">
                            <input
                              type="checkbox"
                              checked={selectedTypes.includes(opt)}
                              onChange={() => toggleType(opt)}
                              className="accent-[#7a0f2e]"
                            />
                            <span>{opt}</span>
                          </label>
                        ))}
                        <div className="sticky bottom-0 flex gap-2 p-2 bg-white border-t">
                          <button type="button" onClick={() => setSelectedTypes([])} className="flex-1 py-1 text-[11px] border rounded hover:bg-gray-50">
                            Clear
                          </button>
                          <button type="button" onClick={() => setOpenDd(null)} className="flex-1 py-1 text-[11px] text-white bg-[#7a0f2e] rounded hover:bg-[#5c0a22]">
                            Done
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* 3. Budget (optional, options change with the tab) */}
                <div className="relative flex items-center h-8 md:h-8 px-2 border border-gray-200 rounded-md focus-within:border-[#7a0f2e]">
                  <span
                    aria-hidden="true"
                    className="flex items-center justify-center w-3 h-3 text-[7px] text-white bg-[#7a0f2e] rounded-full shrink-0"
                  >
                    <FaRupeeSign />
                  </span>
                  <select
                    id="budget"
                    name="budget"
                    aria-label="Budget (optional)"
                    value={budget}
                    onChange={(e) => setBudget(e.target.value)}
                    className="w-full h-full px-2 text-xs md:text-[11px] text-gray-700 bg-transparent outline-none appearance-none cursor-pointer"
                  >
                    <option value="">{isMonthly ? "Budget per month (Optional)" : "Budget (Optional)"}</option>
                    {budgetOptions.map((b) => (
                      <option key={b.value} value={b.value}>
                        {b.label}
                      </option>
                    ))}
                  </select>
                  <FiChevronDown size={12} aria-hidden="true" className="absolute text-gray-500 pointer-events-none right-2" />
                </div>

                {/* 4. More filters */}
                <div className="relative w-full" data-dd>
                  <button
                    type="button"
                    onClick={() => {
                      setShowMoreFilters((v) => !v);
                      setOpenDd(null);
                    }}
                    className="flex items-center w-full h-8 md:h-8 px-2 text-left border border-gray-200 rounded-md hover:border-[#7a0f2e] transition bg-white"
                  >
                    <FiSliders size={12} className="text-[#7a0f2e] shrink-0" aria-hidden="true" />
                    <span className="flex-1 px-2 text-xs md:text-[11px] text-gray-700 truncate">
                      {selectedBhk || selectedFurnishing || selectedConstruction
                        ? `${selectedBhk ? selectedBhk + " " : ""}${selectedFurnishing ? selectedFurnishing + " " : ""}`
                        : "More Filters"}
                    </span>
                    <FiChevronDown
                      size={12}
                      className={`text-gray-500 transition-transform duration-200 ${showMoreFilters ? "rotate-180" : ""}`}
                      aria-hidden="true"
                    />
                  </button>

                  {/* Filter Options Popover */}
                  {showMoreFilters && (
                    <div className="absolute left-0 right-0 z-50 p-3 mt-1 bg-white border border-gray-200 rounded-lg shadow-xl space-y-2.5 text-xs">
                      {/* BHK Options */}
                      {showBhk && (
                      <div>
                        <label className="block mb-1 text-[11px] font-semibold text-gray-700">
                          BHK Configuration
                        </label>
                        <div className="flex flex-wrap gap-1">
                          {["1 BHK", "2 BHK", "3 BHK", "4+ BHK"].map((bhk) => (
                            <button
                              key={bhk}
                              type="button"
                              onClick={() => setSelectedBhk(selectedBhk === bhk ? "" : bhk)}
                              className={`px-2 py-0.5 text-[10px] rounded border transition ${selectedBhk === bhk
                                  ? "bg-[#7a0f2e] text-white border-[#7a0f2e]"
                                  : "bg-gray-50 text-gray-700 border-gray-200 hover:bg-gray-100"
                                }`}
                            >
                              {bhk}
                            </button>
                          ))}
                        </div>
                      </div>
                      )}

                      {/* Furnishing Status */}
                      {showFurnishing && (
                      <div>
                        <label className="block mb-1 text-[11px] font-semibold text-gray-700">
                          Furnishing
                        </label>
                        <div className="flex flex-wrap gap-1">
                          {["Fully Furnished", "Semi-Furnished", "Unfurnished"].map((furnish) => (
                            <button
                              key={furnish}
                              type="button"
                              onClick={() => setSelectedFurnishing(selectedFurnishing === furnish ? "" : furnish)}
                              className={`px-2 py-0.5 text-[10px] rounded border transition ${selectedFurnishing === furnish
                                  ? "bg-[#7a0f2e] text-white border-[#7a0f2e]"
                                  : "bg-gray-50 text-gray-700 border-gray-200 hover:bg-gray-100"
                                }`}
                            >
                              {furnish}
                            </button>
                          ))}
                        </div>
                      </div>
                      )}

                      {/* Construction Status */}
                      {showConstruction && (
                      <div>
                        <label className="block mb-1 text-[11px] font-semibold text-gray-700">
                          Construction Status
                        </label>
                        <div className="flex flex-wrap gap-1">
                          {["Ready to Move", "Under Construction"].map((status) => (
                            <button
                              key={status}
                              type="button"
                              onClick={() => setSelectedConstruction(selectedConstruction === status ? "" : status)}
                              className={`px-2 py-0.5 text-[10px] rounded border transition ${selectedConstruction === status
                                  ? "bg-[#7a0f2e] text-white border-[#7a0f2e]"
                                  : "bg-gray-50 text-gray-700 border-gray-200 hover:bg-gray-100"
                                }`}
                            >
                              {status}
                            </button>
                          ))}
                        </div>
                      </div>
                      )}

                      {/* Clear Filters Button */}
                      {(selectedBhk || selectedFurnishing || selectedConstruction) && (
                        <button
                          type="button"
                          onClick={() => {
                            setSelectedBhk("");
                            setSelectedFurnishing("");
                            setSelectedConstruction("");
                          }}
                          className="w-full pt-1 text-center text-[10px] text-[#7a0f2e] underline font-medium"
                        >
                          Reset Filters
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>

              {/* Search button */}
              <button
                type="button"
                className="flex items-center justify-center w-full h-9 md:h-8 gap-1.5 mt-2.5 text-xs font-medium text-white transition rounded-md bg-[#7a0f2e] hover:bg-[#5c0a22]"
                onClick={handleSearch}
              >
                <span>Search Properties</span>
                <FaArrowRight size={9} aria-hidden="true" />
              </button>

              {/* Error message */}
              {error && (
                <div className="mt-2 text-center" role="alert">
                  <span className="inline-block px-2 py-1 text-[11px] text-white bg-gray-800 rounded">
                    {error}
                  </span>
                </div>
              )}

              {/* Recent searches
              {recent.length > 0 && (
                <div className="mt-3" aria-label="Recent searches">
                  <div className="flex items-center justify-between mb-1.5">
                    <p className="flex items-center gap-1 text-[11px] font-medium text-gray-700">
                      <FiClock className="text-[#7a0f2e]" aria-hidden="true" /> Recent searches
                    </p>
                    <button
                      type="button"
                      onClick={() => setShowAllRecent((v) => !v)}
                      className="text-[10px] font-medium text-[#7a0f2e] underline"
                    >
                      {showAllRecent ? "Show less" : "View all searches"}
                    </button>
                  </div>
                  <ul className="p-0 m-0 space-y-1 list-none">
                    {(showAllRecent ? recent : recent.slice(0, 1)).map((r) => (
                      <li key={r.label}>
                        <button
                          type="button"
                          onClick={() => runRecent(r)}
                          title={r.label}
                          className="flex items-center w-full gap-1.5 px-2 py-1 text-left text-[11px] text-gray-700 bg-gray-50 border border-gray-200 rounded-md hover:border-[#7a0f2e] transition"
                        >
                          <FiClock size={10} className="text-gray-400 shrink-0" aria-hidden="true" />
                          <span className="truncate">{r.label}</span>
                        </button>
                      </li>
                    ))}
                  </ul>
                  {showAllRecent && (
                    <button type="button" onClick={clearRecent} className="mt-1 text-[10px] text-gray-500 underline">
                      Clear history
                    </button>
                  )}
                </div>
              )} */}

              {/* Popular cities */}
              <nav aria-label="Popular cities" className="mt-3">
                <p className="flex items-center gap-1 mb-1.5 text-[11px] font-medium text-gray-700">
                  <FaFire className="text-[#7a0f2e]" aria-hidden="true" /> Popular Cities
                </p>
                <div className="flex flex-wrap gap-1">
                  {popularCities.map((city) => (
                    <button
                      key={city.name}
                      type="button"
                      onClick={() => addLocation(city.name)}
                      className="px-2.5 py-0.5 text-[11px] text-gray-700 no-underline bg-gray-100 rounded-full hover:bg-[#7a0f2e] hover:text-white transition cursor-pointer"
                    >
                      {city.name}
                    </button>
                  ))}
                </div>
              </nav>
            </div>
          </div>

          {/* ================= RIGHT : HEADLINE + STATS ================= */}
          <div className="min-w-0 text-white md:pt-1">
            <p className="mb-1 text-[11px] font-semibold tracking-[0.14em] text-[#f2b632]">
              WELCOME TO ZEROBRIKS
            </p>
            <h1
              id="hero-heading"
              className="text-[22px] font-bold leading-[1.12] sm:text-[27px] xl:text-[31px] md:max-w-[62%] lg:max-w-none"
            >
              Homes.
              <br />
              Investments.
              <br />
              Opportunities.
              <br />
              <span className="text-[#f2b632]">Directly from Owners.</span>
            </h1>
            <p className="mt-2.5 text-[13px] font-semibold">
              No brokerage. No middlemen.
            </p>
            <p className="text-xs text-gray-100">
              A smarter way to buy, rent or sell property.
            </p>

            {/* Feature icons */}
            <ul className="flex mt-4 overflow-x-auto divide-x list-none md:max-w-[340px] divide-white/20 p-0 m-0 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
              {[
                { icon: <FaPercent />, a: "Zero", b: "Brokerage" },
                { icon: <FaShieldAlt />, a: "Verified", b: "Owners" },
                { icon: <FaMagic />, a: "AI Smart", b: "Match" },
                { icon: <FaCamera />, a: "Virtual", b: "Tour" },
                { icon: <FaLock />, a: "Secure &", b: "Transparent" },
              ].map((f) => (
                <li
                  key={f.a}
                  className="flex flex-col items-center flex-1 min-w-[64px] px-1 text-center"
                >
                  <span
                    aria-hidden="true"
                    className="flex items-center justify-center w-6 h-6 mb-1 text-xs text-white bg-[#7a0f2e] rounded-full ring-1 ring-white/30"
                  >
                    {f.icon}
                  </span>
                  <span className="text-[11px] leading-tight">
                    {f.a}
                    <br />
                    {f.b}
                  </span>
                </li>
              ))}
            </ul>

            {/* Stats bar */}
            <div className="grid grid-cols-2 mt-4 text-gray-900 border border-white/70 shadow-xl lg:translate-y-5 rounded-xl bg-[#f6ede4]/95 backdrop-blur lg:grid-cols-4 divide-[#e6d6c6] [&>*:nth-child(odd)]:border-r [&>*:nth-child(-n+2)]:border-b lg:[&>*]:border-b-0 lg:[&>*]:border-r lg:[&>*:last-child]:border-r-0 [&>*]:border-[#e6d6c6]">
              {[
                {
                  icon: <FaHome />,
                  tone: "bg-[#fde3c8] text-[#e8730c]",
                  value: "50,000+",
                  label: "Property Listings",
                  sub: "Across India",
                },
                {
                  icon: <FaUsers />,
                  tone: "bg-[#f7dde2] text-[#7a0f2e]",
                  value: "10,000+",
                  label: "Verified Owners",
                  sub: "Genuine & Trusted",
                },
                {
                  icon: <FaBuilding />,
                  tone: "bg-[#f7dde2] text-[#7a0f2e]",
                  value: "50+",
                  label: "Cities Across India",
                  sub: "And Growing",
                },
                {
                  icon: <FaStar />,
                  tone: "bg-[#fdf0c9] text-[#e6a817]",
                  value: "4.8/5",
                  label: "User Rating",
                  sub: "Trusted by Thousands",
                },
              ].map((s) => (
                <div
                  key={s.label}
                  className="flex items-center justify-center gap-2 px-2 py-3 min-h-[64px]"
                >
                  <span
                    aria-hidden="true"
                    className={`flex items-center justify-center w-8 h-8 text-sm rounded-full shrink-0 ${s.tone}`}
                  >
                    {s.icon}
                  </span>
                  <div className="flex-1 min-w-0 leading-tight text-left">
                    <p className="text-[13px] font-bold">{s.value}</p>
                    <p className="text-[11px] text-gray-700 truncate">{s.label}</p>
                    <p className="text-[10px] mb-2 text-gray-600 truncate">{s.sub}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* ---- Decorative: gold arc + maroon circle badge ---- */}
          <div
            aria-hidden="true"
            className="absolute hidden lg:block right-8 top-3 w-[170px] h-[170px] pointer-events-none"
          >
            <div className="absolute inset-0 rounded-full border border-[#f2b632]/70 border-b-transparent border-l-transparent -rotate-12" />
            <div className="absolute inset-0 m-auto flex flex-col items-center justify-center w-[160px] h-[160px] p-3 text-white rounded-full shadow-2xl bg-[#7a0f2e]/25 backdrop-blur-sm">
              <span className="text-[15px]">Your</span>
              <span className="text-[15px] leading-snug">Property Journey</span>
              <span className="text-[15px] leading-snug">Made Simple.</span>
              <span className="w-5 h-[2px] mt-1 bg-[#f2b632]" />
            </div>
          </div>

          {/* ---- Decorative: verified owners pill ---- */}
          <div className="absolute hidden lg:flex items-center right-5 bottom-[200px] p-1 bg-white/95 rounded-full shadow-xl">
            <div className="flex items-center -space-x-2 pl-0.5">
              {[1, 2, 3].map((n) => (
                <img
                  key={n}
                  src="/image/pp.png"
                  alt={`Verified property owner ${n}`}
                  width="25"
                  height="25"
                  loading="lazy"
                  className="object-cover w-[25px] h-[25px] bg-gray-300 border-2 border-white rounded-full"
                />
              ))}
            </div>
            <div className="flex items-center gap-2 py-1 pl-3 pr-1.5 ml-2 text-white rounded-full bg-[#7a0f2e]">
              <div className="leading-tight text-left">
                <p className="text-[10px] font-bold">10,000+</p>
                <p className="text-[10px] whitespace-nowrap">Verified Property Owners</p>
              </div>
              <span
                aria-hidden="true"
                className="flex items-center justify-center w-5 h-5 text-[9px] border border-[#f2b632] rounded-full text-[#f2b632] shrink-0"
              >
                <FaArrowRight />
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* ============================================================ */}
      {/*  SECTION 2 : DISCOVER PROPERTIES                             */}
      {/* ============================================================ */}
      <section
        aria-labelledby="discover-heading"
        className="bg-gradient-to-b from-[#fdf9f6] via-[#fdf9f6] to-[#f7dcc3]"
      >
        <div className="px-3 pt-4 pb-20 mx-auto max-w-7xl sm:px-5 lg:px-8 lg:pt-8">
          <div className="flex flex-col gap-2 mb-3.5 md:flex-row md:items-end md:justify-between">
            <div>
              <p className="mb-1 text-[11px] font-semibold tracking-[0.14em] text-[#b0701f]">
                EXPLORE BY PROPERTY TYPE
              </p>
              <h2
                id="discover-heading"
                className="text-lg font-bold text-[#14213d] sm:text-xl"
              >
                Discover Properties{" "}
                <span className="text-[#7a0f2e]">Across India</span>
              </h2>
            </div>

            <div className="flex flex-col gap-2 md:flex-row md:items-center md:gap-5">
              <p className="max-w-[300px] text-xs leading-relaxed text-gray-700">
                From dream homes to high-value investments, explore verified
                properties directly from owners in top cities across India.
              </p>
              <Link
                to={{ pathname: "/property", state: { propertyType: "Buy" } }}
                className="inline-flex items-center self-start gap-1.5 px-3.5 py-1 text-[11px] font-medium text-[#7a0f2e] no-underline bg-white border border-[#7a0f2e] rounded-full whitespace-nowrap hover:bg-[#7a0f2e] hover:text-[#14213d] hover:no-underline hover:border-[#7a0f2e] transition"
              >
                View All Properties <FaArrowRight size={8} aria-hidden="true" />
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-5">
            {typeCards.map((c) => (
              <Link
                key={c.title}
                to={{ pathname: "/property", state: { propertyType: c.type } }}
                aria-label={`${c.title} – ${c.sub}`}
                className="relative block overflow-hidden no-underline transition shadow-md group rounded-lg hover:shadow-xl hover:-translate-y-1 hover:no-underline"
              >
                <img
                  src={c.img}
                  alt={`${c.title}: ${c.sub}`}
                  className="object-cover w-full h-[116px] sm:h-[130px]"
                  loading="lazy"
                  decoding="async"
                />
                <div className="absolute flex items-center gap-1.5 p-1.5 bg-white shadow-lg inset-x-1.5 bottom-1.5 rounded-md">
                  <span
                    aria-hidden="true"
                    className="flex items-center justify-center w-6 h-6 text-xs text-[#7a0f2e] rounded-full bg-[#f9e4e8] shrink-0"
                  >
                    {c.icon}
                  </span>
                  <span className="flex-1 min-w-0 leading-tight">
                    <span className="block text-xs font-semibold text-[#14213d] truncate">
                      {c.title}
                    </span>
                    <span className="block text-[11px] text-gray-600 truncate">
                      {c.sub}
                    </span>
                  </span>
                  <span
                    aria-hidden="true"
                    className="flex items-center justify-center w-4 h-4 text-[7px] text-[#b0701f] border border-[#c8962e] rounded-full shrink-0"
                  >
                    <FaArrowRight />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Search;